import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c0f4bd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "person-link"
}
const _hoisted_2 = {
  key: 1,
  class: "link-placeholder"
}

import { computed } from 'vue'
import { useViewPersonStore } from '@/rd/ViewPersonStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonLink',
  props: {
    personId: String,
    disabled: Boolean,
},
  setup(__props) {

const props = __props;



const viewPersonStore = useViewPersonStore()
const viewPersonRef = computed(() => viewPersonStore.getAsyncPerson(props.personId)?.data)
const displayName = computed(() => viewPersonRef.value?.displayName)


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (viewPersonRef.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!props.disabled)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: viewPersonRef.value.pageUrl!,
              class: "link-dark"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(displayName.value), 1),
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(displayName.value), 1))
      ]))
    : _createCommentVNode("", true)
}
}

})